import { TemplateRef } from '@angular/core';

import { isNonNullable } from '@qtek/shared/utils';
import { FilterBase, FilterChangeBase } from './base';

interface CheckboxOption {
  /** Translation key for that option. */
  name: string;

  /** Value of checkbox. */
  value: any;

  /** Whether option is selected. */
  selected?: boolean;

  /** Type of checkbox check for now only for masking items */
  type?: 'mask';
}

export interface CheckboxValues {
  options?: CheckboxOption[];
}

export interface CheckboxFilter extends FilterBase<CheckboxValues> {
  type: 'checkbox';

  /** Template for checkbox name. */
  nameTemplate?: TemplateRef<any>;
}

export type CheckboxFilterChange = FilterChangeBase<
  CheckboxValues,
  CheckboxFilter
>;

/**
 * Predicate function for checkbox filter.
 *
 * @param filters List of filter configs.
 * @param row Row of data to filter.
 * @param valueAccessor
 */
export function checkboxFilter<T>(
  filters: CheckboxFilterChange[],
  row: T,
  valueAccessor: (row: T, id: string) => any
): boolean {
  return filters.every(({ values, config }) => {
    const value = valueAccessor(row, config.id);
    const selected = isNonNullable(values.options)
      ? values.options.filter(v => v.selected)
      : [];

    if (!selected.length) {
      return true;
    }

    return selected.some(v => {
      return v.type && v.type === 'mask'
        ? (value & v.value) === v.value
        : v.value === value;
    });
  });
}
